<template>
  <!--
    - Choisit le mot à tester parmi les mots déjà vu
    - Prépare les props à envoyer au sous-composant
    -->

  <vocabulary-quiz v-if="currentTest === 'quiz'" :key="uniqueKey" class="flexwrap centercenter"
  :testedWord="currentWord"
  :wordsList="sessionWordsList.vocab.slice()"
                   :chosen-lemma-index="chosenLemmaIndex"
  @answer="next($event, 'quiz')">
  </vocabulary-quiz>

  <vocabulary-speech-to-text v-else-if="currentTest === 'speech'" :key="uniqueKey" class="flexwrap centercenter"
                             v-bind="testedWord"
                             :other-words="otherWords"
                             answerLanguage='en'
                             @answer="next($event, 'syll')">
  </vocabulary-speech-to-text>

  <vocabulary-spelling v-else-if="currentTest === 'spelling'" :key="uniqueKey" class="flexwrap centercenter"
                        v-bind="testedWord"
                        answerLanguage='en'
                        @answer="next($event, 'spell')">
  </vocabulary-spelling>

  <vocabulary-syllables v-else-if="currentTest === 'syllables'" :key="uniqueKey" class="flexwrap centercenter"
                        :word="testedWord"
                        :other-words="otherWords"
                        answerLanguage='en'
                        @answer="next($event, 'syll')">
  </vocabulary-syllables>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: "vocabularyCardTest",

  props: {
    vocab: Array,
  },

  components: {
    VocabularySpeechToText: () => import(/* webpackPrefetch: true */ '@/components/vocabularySpeechToText.vue'),
    vocabularySyllables: () => import(/* webpackPrefetch: true */ '@/components/vocabularySyllables.vue'),
    vocabularyQuiz: () => import(/* webpackPrefetch: true */ '@/components/vocabularyQuiz.vue'),
    vocabularySpelling: () => import(/* webpackPrefetch: true */ '@/components/vocabularySpelling.vue')
  },

  created() {
    // Séléctionne un mot a tester parmi les déjà vu
    this.set_currentWord(this.selectTestedWord(this.wordNum, this.vocab));
    this.testedWord = {
      english: this.currentWord.lemma.english,
      french: this.currentWord.lemma.separateTrads[0]
    }

    if(this.currentTest === 'speech') {
      this.language = 'en'
    }
    else if(this.currentTest === 'syllables') {
      this.language = 'en'
    }

    this.otherWords = this.selectRandomList(4, this.sessionWordsList.vocab, this.language)

  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile'
    ]),
    ...mapGetters('session', [
      'wordNum',
      'testNum',
      'testNumSerie',
      'learntWords'
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
    ]),
    ...mapGetters('session', [
      'currentWord',
      'sessionWordsList'
    ]),
    currentTest: function() {
      if(this.currentWord.lemmaCount === 3) {
        return 'quiz'
      }
      else if(this.currentWord.lemmaCount === 2) {
        return 'speech'
      }
      else if(this.currentWord.lemmaCount === 1) {
        return 'spelling'
      }
      return 'quiz'

    },

    uniqueKey: function() {
      return this.numTest
    }
  },

  watch: {
    'currentWord.lemma.english': function() {
      this.testedWord = {
        english: this.currentWord.lemma.english,
        french: this.currentWord.lemma.separateTrads[0]
      }
      // On change le type de test selon le count du mot courant
      if(this.currentTest === 'quiz') {
        this.language = 'fr'
      }
      else if(this.currentTest === 'speech') {
        this.language = 'en'
      }
      else if(this.currentTest === 'syllables') {
        this.language = 'en'
      }
      this.otherWords = this.selectRandomList(4, this.sessionWordsList.vocab, this.language)
      //this.numTest++
    }
  },

  methods: {
    ...mapActions('session', [
      'set_currentWord',
      'inc_learntWord',
      'add_learntLemmasId'
    ]),

    next: function (isCorrectAnswer, test) {
      // incrémenter le count du mot
      if(isCorrectAnswer) {
        this.sessionWordsList.vocab[this.chosenLemmaIndex].lemmaCount -= 1;
        this.inc_learntWord(this.currentWord.id)
        if (this.currentWord.lemmaCount === 0) {
          //this.profile.datas.points += 5
          //this.set_stars(this.stars + 1);
          //this.add_learntWords(this.words[0].lemma.english);
          this.add_learntLemmasId(this.currentWord.lemma.id)
        }
        return this.$emit('nextClicked');
      }
      else {
        //this.vocab[this.chosenLemmaIndex].lemmaCount += 1;
        // Séléctionne un mot a tester parmi les déjà vu
        this.set_currentWord(this.selectTestedWord(this.wordNum, this.vocab));

        if(test === ('syll')) {
          this.testedWord = {
            english: this.currentWord.lemma.english,
            french: this.currentWord.lemma.separateTrads[0]
          }
        }
        if(this.currentWord.lemma.english === this.$session.get('lastTestedWord')) {
          this.numTest++;
        }
      }
    },

    selectTestedWord(wordNum, liste) {
      let randomNb = -1;
      let conditions = false;
      // Tant que les conditions du mot aléatoire ne sont pas réunies, on en choisi un autre
      do {
        randomNb = this.nbAlea(0, wordNum);
        // Si le mot choisi aléatoirement est le même que le dernier quizz proposé (et qu'il reste 2 mots dans la liste)
        // OU s'il a déjà été présenté 2 fois
        // OU s'il est le même que le mot qui vient d'être vu à la slide précédente,
        if ((liste[randomNb].lemma.english === this.$session.get('lastTestedWord') && this.remainingWords(liste, wordNum) > 1) || liste[randomNb].lemmaCount < 1 || (this.testNumSerie === 1 && liste[randomNb].lemma.english === liste[wordNum - 1].lemma.english)) {
          conditions = false;
        } else {
          conditions = true;
        }

      }
      while (!conditions);

      this.$session.set('lastTestedWord', liste[randomNb].lemma.english);
      this.chosenLemmaIndex = randomNb;
      //liste[randomNb].lemmaCount--;

      return liste[randomNb];
    },

    nbAlea(min, max) {
      let nb = Math.trunc((Math.random() * max + min));
      return nb;
    },

    remainingWords(liste, wordnum) {
      let remainingWords = [];
      if (wordnum >= 1) {
        for (let i = 0; i < wordnum; i++) {
          if (liste[i].lemmaCount >= 1) {
            remainingWords.push(i);
          }
        }
      }
      return remainingWords.length;
    },

    selectRandomList(nbWords, list, language) {
      let startingArray = []
      let finalArray = []
      let currentWord = {}
      if(language === 'en') {
        currentWord = this.currentWord.lemma.english
        // On crée une liste de mots à partir de la liste d'objets
        list.forEach((element) => {
          if(element.lemma.english !== currentWord) {
            startingArray.push(element.lemma.english)
          }
        })
      }
      else {
        currentWord = this.currentWord.lemma.separateTrads[0]
        // On crée une liste de mots à partir de la liste d'objets
        list.forEach((element) => {
          if(element.lemma.separateTrads[0] !== currentWord) {
            startingArray.push(element.lemma.separateTrads[0])
          }
        })
      }

      // Si on doit renvoyer >= mots qu'il n'y a dans la liste, on crée simplement une liste avec les mots reçus + le mot anglais à tester
      if (nbWords >= startingArray.length) {
        return startingArray.concat(currentWord);
      }
      // Sinon on choisit aléatoirement n éléments du tableau pour en renvoyer un autre
      else {
        for(let i=0; i<nbWords; i++)  {
          let randomNb = Math.floor(Math.random() * Math.floor(startingArray.length));
          finalArray.push(startingArray[randomNb]);
          startingArray.splice(randomNb, 1);
        }
      }
      // On ajoute le mot à apprendre à la liste
      return finalArray.concat(currentWord);
    },
  },

  data() {
    return {
      testedWord: {},
      word: {
        french: '',
        english: ''
      },
      otherWords: [],
      language: 'en',
      chosenLemmaIndex: -1,
      numTest: 0,
    }
  }
}
</script>

<style scoped>
.proposition {
  position: relative;
  font-size: 150%;
  font-weight: bold;
  width: 14vw;
  height: 2.5em;
  min-width: fit-content;
}
</style>